import { PayloadAction } from "@reduxjs/toolkit";
import React, { Dispatch } from "react";
import { Toastface } from "../../../interface/interface";

function ReportPopup({
  data,
  dispatch,
}: {
  data: any;
  dispatch: Dispatch<PayloadAction<Toastface>>;
}) {
  return (
    <div className="report-popup">
      <div className="title">신고 대상 본문</div>
      <div className="content">{data}</div>
    </div>
  );
}

export default ReportPopup;
